import axios from 'axios';
import {
  CREATE_NEW_LOGIN,
  DEFAULTLOGINENTRY,
  
  REGISTER_LOGIN_REQUEST,
  ADD_LOGIN_REQUEST,
  UPDATE_LOGIN_REQUEST,
  DELETE_LOGIN_REQUEST,
  GET_LOGIN_REQUEST,
  GET_LOGINS_LIST_REQUEST,
  VALIDATE_PASSWORD_REQUEST,

  GET_LOGIN_SUCCESS,
  GET_LOGINS_LIST_SUCCESS,
  DELETE_LOGIN_SUCCESS,
  ADD_LOGIN_SUCCESS,
  REGISTER_LOGIN_SUCCESS,
  UPDATE_LOGIN_SUCCESS,
  VALIDATE_PASSWORD_SUCCESS,

  GET_LOGIN_FAIL,
  GET_LOGINS_LIST_FAIL,
  DELETE_LOGIN_FAIL,
  ADD_LOGIN_FAIL,
  UPDATE_LOGIN_FAIL,
  REGISTER_LOGIN_FAIL,
  VALIDATE_PASSWORD_FAIL,


  /*** SPECIFIC TO THIS APP --- START */
  ADD_LOGIN_PROGRAM_REQUEST,
  ADD_LOGIN_PROGRAM_SUCCESS,
  ADD_LOGIN_PROGRAM_FAIL,

  DELETE_LOGIN_PROGRAM_REQUEST,
  DELETE_LOGIN_PROGRAM_SUCCESS,
  DELETE_LOGIN_PROGRAM_FAIL,
  /*** SPECIFIC TO THIS APP --- END */

} from './action-constants';

const TABLENAME = 'logins';
const REGISTERLOGIN = 'register';
const DEACTIVATELOGIN = 'logins/deactivate';
const PAGE_NUMBER = "?page=";
const QUERY_LIMIT = "&limit=";

/*** SPECIFIC TO THIS APP --- START */
const TABLENAME_PROGRAMSLIST_ADD = 'logins/assignprogram';
const TABLENAME_PROGRAMSLIST_DELETE = 'logins/unassignprogram';
/*** SPECIFIC TO THIS APP --- END */

export const createNewLogin = () => async dispatch => {
  try {
    dispatch({
      type: CREATE_NEW_LOGIN,
      payload: { login: DEFAULTLOGINENTRY }
    })
  } catch (err) {
    console.log('4409 - Error : ', err);
  }
}

export const getLoginsList = (page,limit,search,orderby) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME + PAGE_NUMBER + page + QUERY_LIMIT + limit ;
  dispatch({
    type: GET_LOGINS_LIST_REQUEST
  })
  try {
    const { data } = await axios.get(
      JSONURL
      // , HEADERS
    )
    dispatch({
      type: GET_LOGINS_LIST_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: GET_LOGINS_LIST_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: GET_LOGINS_LIST_FAIL,
        payload: err.message
      })
    }
  }
}
    
export const getLogin = (id) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id;
  dispatch({
    type: GET_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.get(
      JSONURL
      // , HEADERS
    )
    dispatch({
      type: GET_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: GET_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: GET_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}

export const addLogin = (params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/';
  dispatch({
    type: ADD_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.post(
      JSONURL, 
      params
      // , HEADERS
    )
    dispatch({
      type: ADD_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: ADD_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: ADD_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}


/*** replaced with RegisterLogin_Auto_Sign_In in actions-auth file */
export const registerLogin = (params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + REGISTERLOGIN + '/';
  dispatch({
    type: REGISTER_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.post(
      JSONURL, 
      params
      // , HEADERS
    )
    dispatch({
      type: REGISTER_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: REGISTER_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: REGISTER_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}

export const updateLogin = (id, params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id;
  dispatch({
    type: UPDATE_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.put(
      JSONURL, 
      params
      // , HEADERS
    )
    dispatch({
      type: UPDATE_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: UPDATE_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: UPDATE_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}

export const deleteLogin = (id) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id;
  dispatch({
    type: DELETE_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.delete(
      JSONURL
      // , HEADERS
    )
    dispatch({
      type: DELETE_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: DELETE_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: DELETE_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}

export const deactivateLogin = (id, params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + DEACTIVATELOGIN + '/' + id;
  dispatch({
    type: DEACTIVATE_LOGIN_REQUEST
  })
  try {
    const { data } = await axios.put(
      JSONURL,
      params
      // , HEADERS
    )
    dispatch({
      type: DEACTIVATE_LOGIN_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: DEACTIVATE_LOGIN_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: DEACTIVATE_LOGIN_FAIL,
        payload: err.message
      })
    }
  }
}


export const validatePassword = (id) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/password/';
  dispatch({
    type: VALIDATE_PASSWORD_REQUEST
  })
  try {
    const { data } = await axios.get(
      JSONURL + id
      // , HEADERS
    )
    dispatch({
      type: VALIDATE_PASSWORD_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: VALIDATE_PASSWORD_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: VALIDATE_PASSWORD_FAIL,
        payload: err.message
      })
    }
  }
}






/*** SPECIFIC TO THIS APP --- START */

export const loginAssignProgram = (params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_PROGRAMSLIST_ADD;
  dispatch({
    type: ADD_LOGIN_PROGRAM_REQUEST
  })
  try {
    const { data } = await axios.post(
      JSONURL,
      params
      // , HEADERS
    )
    dispatch({
      type: ADD_LOGIN_PROGRAM_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: ADD_LOGIN_PROGRAM_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: ADD_LOGIN_PROGRAM_FAIL,
        payload: err.message
      })
    }
  }
}

export const loginUnAssignProgram = (params) => async dispatch => {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_PROGRAMSLIST_DELETE;
  dispatch({
    type: DELETE_LOGIN_PROGRAM_REQUEST
  })
  try {
    const { data } = await axios.post(
      JSONURL,
      params
      // , HEADERS
    )
    dispatch({
      type: DELETE_LOGIN_PROGRAM_SUCCESS,
      payload: data
    })
  } catch (err) {
    if (err.message === 'Network Error') {
      dispatch({
        type: DELETE_LOGIN_PROGRAM_FAIL,
        payload: 'Data Server Appears To Be Offline'
      })
    } else {
      dispatch({
        type: DELETE_LOGIN_PROGRAM_FAIL,
        payload: err.message
      })
    }
  }
}

/*** SPECIFIC TO THIS APP --- END */














// const TABLENAME_PAGINATION = 'logins-pagination';
// const SEARCH_QUERY = "&search=";
// const ORDER_BY = "&orderby=";

// /*** PAGINATION --- START */
// export function getLoginsList_PAGINATION(page,limit,orderby) {
//   const JSONURL = DATABASEURL + "/" + TABLENAME_PAGINATION + PAGE_NUMBER + page + QUERY_LIMIT + limit + ORDER_BY + orderby ;
//                   // const JSONURL = DATABASEURL + "/" + TABLENAME + PAGE_NUMBER + page + QUERY_LIMIT + limit + ORDER_BY + orderby ;
//                                                                           // GET  http://localhost:4444/logins?page=2&limit=5
//                                                                           console.log('23-23023 JSONURL = ', JSONURL);
//   return {
//       type: GET_LOGINS_LIST_PAGINATION,
//       payload: new Promise((resolve, reject) => {
//         axios
//           .get(JSONURL)
//           .then(function (response) {
//             resolve(response);
//           })
//           .catch(function (error) {
//             reject(error);
//           });
//       })
//     };
//   }
  
// /*** PAGINATION --- END */



// /*** PAGINATION --- START */
// export function getLoginsList(page,limit,search,orderby) {
//   const JSONURL = DATABASEURL + "/" + TABLENAME_PAGINATION + PAGE_NUMBER + page + QUERY_LIMIT + limit + SEARCH_QUERY + search ;
//   // const JSONURL = DATABASEURL + "/" + TABLENAME_PAGINATION + PAGE_NUMBER + page + QUERY_LIMIT + limit + SEARCH_QUERY + search + ORDER_BY + orderby ;
//   // const JSONURL = DATABASEURL + "/" + TABLENAME_PAGINATION + PAGE_NUMBER + page + QUERY_LIMIT + limit + ORDER_BY + orderby ;
//                   // const JSONURL = DATABASEURL + "/" + TABLENAME + PAGE_NUMBER + page + QUERY_LIMIT + limit + ORDER_BY + orderby ;
//                                                                           // GET  http://localhost:4444/logins?page=2&limit=5
//                                                                           console.log('24-24024 JSONURL = ', JSONURL);
//   return {
//       type: GET_LOGINS_LIST_PAGINATION,
//       payload: new Promise((resolve, reject) => {
//         axios
//           .get(JSONURL)
//           .then(function (response) {
//             resolve(response);
//           })
//           .catch(function (error) {
//             reject(error);
//           });
//       })
//     };
//   }
  
// /*** PAGINATION --- END */





